module.exports = __webpack_public_path__ + "img/ring_r_l_0_1.09b0ddd3.png";